<template>
  <modal-component ref="modalView" v-show="isOpen" @close="onClose"  @mask-click="onClose" :container-width="'40vw'">
    <template slot="header">
      <h2>{{ $t('grid.maintenanceview.title_new') }}</h2>
    </template>
    <template slot="body">
      <div class="container-fluid pt-3">
        <div class="row">
          <div class="col">
              <alerter ref="alertbox"/>
          </div>
        </div>

        <template v-if="showForm">
          <div class="form-group">
            <label for="exampleInputEmail1">{{ $t('name') }}</label>
            <text-input ref="nameInput" v-bind:textValue="name" v-on:update:textValue="name = $event"/>
          </div>

          <div class="form-group">
            <label for="layoutTypeInput">{{ $t('grid.layout_type.layout_type') }}</label>
            <select v-model="selectedType" class="form-control" id="layoutTypeInput">
              <option v-for="(item, index) in optionTypes" v-bind:key="index" v-bind:value="item.layoutType"> {{ item.description }} </option>
            </select>
          </div>

          <div class="form-group form-check">
            <input type="checkbox" v-model="setAsDefaultLayout" class="form-check-input mr-2" :id="checkID">
            <label class="form-check-label" :for="checkID">{{ $t('grid.maintenanceview.set_as_default_layout')}}</label>
          </div>
        </template>
      </div>
    </template>
    <template slot="footer">
      <loading-button :title="$t('save')" @click="saveChanges()" v-if="showForm" :is-busy="isBusy"/>
    </template>
  </modal-component>
</template>
<script>
import { GridController } from 'controller/gridcontroller.js';
import Alerter from 'components/Alerter.vue';
import ModalComponent from 'components/ModalComponent.vue';
import TextInput from 'components/TextInput.vue';
import LoadingSpinner from 'components/LoadingSpinner.vue';
import lodashDelay from 'lodash/delay';
import {Grid as GridSecurity} from 'libs/classes/security.js';

export default {
  name: 'FlexGridLayoutMaintenanceView',
  components: {
    Alerter,
    'loading-spinner': LoadingSpinner,
    'modal-component': ModalComponent,
    'text-input': TextInput
  },
  props: {
    webController: String,
    existingFlexGridColumns: Array
  },
  data: function () {
    return {
      searchKey: '',
      listItems: [],
      listItemsCopy: [],
      selectedType: null,
      name: '',
      layout: null,
      setAsDefaultLayout: false,
      isBusy: false,
      showForm: true,
      optionTypes: [],
      gridcontroller: null,
      allowChangeSystemViews: false,
      allowChangeUserViews: false,
      isOpen: false
    };
  },
  async created() {
    this.allowChangeSystemViews = await this.$authorize(GridSecurity.AllowChangeSystemViews);
    this.allowChangeUserViews = await this.$authorize(GridSecurity.AllowChangeUserViews);
    this.$log('get grid settings', this.allowChangeSystemViews, this.allowChangeUserViews);
  },
  mounted () {
    this.gridcontroller = new GridController(this.webController);
  },
  methods: {
    showModal: function (layout) {
      this.layout = layout;

      this.optionTypes = [];
      if (this.allowChangeUserViews) {
        this.optionTypes.push({
          description: this.$t('grid.layout_type.user'),
          layoutType: 1
        });
      }
      if (this.allowChangeSystemViews) {
        this.optionTypes.push({
          description: this.$t('grid.layout_type.system'),
          layoutType: 0
        });
      }
      this.selectedType = this.optionTypes[0].layoutType;
      this.isOpen = true;
    },
    onClose() {
      this.isOpen = false;
    },
    closeModal () {
      this.onClose();
    },
    async saveChanges() {
      const self = this;
      self.isBusy = true;

      if (self.layout != null) {
        let obj = {
          Name: self.name,
          FlexGridLayout: self.layout.FlexGridLayout,
          ControlName: self.layout.ControlName,
          LayoutType: self.selectedType,
          SetAsDefaultLayout: self.setAsDefaultLayout
        };

        try {
          let res = await this.gridcontroller.CreateNewFlexGridLayout(obj);
          if (res) {
            this.$toaster.showSuccess(this.$t('grid.maintenanceview.layout_saved'));
            this.$emit('layoutCreated', res);
            self.closeModal();
          }

        } catch (error) {
          self.showAlert(self.$t('grid.maintenanceview.errors.creating_layout'), error);
        } finally {
          self.isBusy = false;
          self.showForm = true;
        }
      }
    },
    showAlert: function (msg, error) {
      console.error(error);
      this.$refs.alertbox.showError(msg);
    }
  },
  computed: {
    modalID () {
      return this._uid + 'modal';
    },
    buttonsBlocked () {
      return this.isBusy;
    },
    checkID () {
      return this.modalID + 'check';
    }
  }
};
</script>

<style lang="scss" scoped>
.form-group {
  &.form-check {
    padding-left: 0px;

    input[type="checkbox"] {
      margin: 0;
    }
    .form-check-input {
      position: relative;
    }
  }
}
</style>
